import { render, staticRenderFns } from "./ProjectStatus.vue?vue&type=template&id=2397e8a2&scoped=true&lang=html"
import script from "./ProjectStatus.vue?vue&type=script&lang=js"
export * from "./ProjectStatus.vue?vue&type=script&lang=js"
import style0 from "./ProjectStatus.vue?vue&type=style&index=0&id=2397e8a2&prod&lang=scss"
import style1 from "./ProjectStatus.vue?vue&type=style&index=1&id=2397e8a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2397e8a2",
  null
  
)

export default component.exports